import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37f3b05a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shipping-details" }

import ShippingDetailsLocationV2 from '@/v2/ShippingDetailsLocationV2.vue';
import ShippingDetailsQuantityV2 from '@/v2/ShippingDetailsQuantityV2.vue';
import ShippingDetailsTotalsV2 from '@/v2/ShippingDetailsTotalsV2.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ShippingDetailsV2',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ShippingDetailsQuantityV2, { class: "shipping-details__quantity" }),
    _createVNode(ShippingDetailsLocationV2, { class: "shipping-details__location" }),
    _createVNode(ShippingDetailsTotalsV2)
  ]))
}
}

})